module.exports = "/_next/static/images/544233f072119755a7487e3724afb732-mockup-transfer-fgts@1x.jpg.webp";